import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Alert } from '@mui/material';
import { useAppDispatch, useAppSelector } from '~/redux';
import { removeAlert } from '~/redux/slices/alertSlice';
import { alertContainerStyle } from './styles';

export const AUTOHIDE_DURATION = 5000;

const RootNotification = () => {
  const dispatch = useAppDispatch();
  const alerts = useAppSelector((state) => state.alert);

  useEffect(() => {
    alerts.forEach((alert) => {
      toast(
        <Alert
          onClose={() => {
            toast.dismiss(alert.id);
            dispatch(removeAlert(alert.id));
          }}
          severity={alert.type}
          sx={{ maxWidth: '50vw', wordBreak: 'break-word' }}
        >
          {alert?.message?.split(', ').map((msg, index) => (
            <div key={index}>{msg}</div>
          ))}
        </Alert>,
        {
          toastId: alert.id,
          autoClose: AUTOHIDE_DURATION,
          style: alertContainerStyle,
          onClose: () => dispatch(removeAlert(alert.id)),
        },
      );
    });
  }, [alerts, dispatch]);

  return <ToastContainer autoClose={AUTOHIDE_DURATION} hideProgressBar newestOnTop closeButton={false} />;
};

export default RootNotification;
